import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import {compose} from "redux";
import {connect} from "react-redux";
import {closeConfirmationModal} from "../../redux/reducers/utils";

function ConfirmationModal(props){

  const closeModal = () => {
    props.closeConfirmationModal();
  }

  const getIcon = () => {
    switch(props.confirmationModalType) {
      case "NO_KEYHOLDERS":
      case "NO_DOCUMENTS":
      case "ARCHIVE_VAULT":
      case "CANCEL_REQUEST":
      case "LOCK_VAULT":
        return <FontAwesomeIcon icon="exclamation-triangle" className="text-warning mr-3 text-2xl sm:text-3xl"/>;
      case "NO_GUARDIANS":
      case "CANCEL_SUBSCRIPTION":
        return <FontAwesomeIcon icon="exclamation-circle" className="text-alert mr-3 text-2xl sm:text-3xl"/>;

    }
  };

  const getTitle = () => {
    switch(props.confirmationModalType) {
      case "NO_KEYHOLDERS":
        return "No Keyholders Selected";
      case "NO_GUARDIANS":
        return "No Guardians Selected";
      case "NO_DOCUMENTS":
        return "No Documents Uploaded";
      case "ARCHIVE_VAULT":
        return "Archive Vault";
      case "CANCEL_REQUEST":
        return "Cancel Access Request";
      case "LOCK_VAULT":
        return "Lock Vault";
      case "CANCEL_SUBSCRIPTION":
        return "Cancel Subscription";
    }
  };

  const getText = () => {
    switch(props.confirmationModalType) {
      case "NO_KEYHOLDERS":
        return <div>
            <p>You haven't selected any keyholders for this vault. Without keyholders, <span className="font-bold text-warning">only you will be able to access this vault</span>.</p>
            <p className="mt-3"><a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>Visit our FAQ</a> for more information on keyholders, and why they're important for emergency situations. You can skip this step for now if you're aren't sure who should be a keyholder.</p>
        </div>;
      case "NO_GUARDIANS":
        return <div>
          <p>You haven't selected any guardians for this vault. Without guardians, <span className="font-bold text-alert">requests for access made by keyholders will be automatically approved</span>.</p>
          <p className="mt-3"><a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>Visit our FAQ</a> for more information on guardians, and why they're important for emergency situations. You can skip this step for now if you're aren't sure who should be a guardian.</p>
        </div>;
      case "NO_DOCUMENTS":
        return <div>
          <p>You haven't uploaded any documents to this vault. </p>
          <p className="mt-3"><a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>Visit our FAQ</a> for suggestions on what you should upload based on the type of vault. You can skip this step for now if you're aren't what documents you'd like to store.</p>
        </div>;
      case "ARCHIVE_VAULT":
        return <div>
          <p>Are you sure you want to archive this vault? This will permanently delete all documents stored in this vault. Other information, such as the vault history, Keyholders, and Guardians will be preserved, but the Vault will be inactive.</p>
          <p className="mt-3"><a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>Visit our FAQ</a> for more details on archiving a vault. </p>
        </div>;
      case "CANCEL_REQUEST":
        return <div>
          <p>Are you sure you want to cancel this access request?</p>
          <p className="mt-3">The owner and guardians will be automatically notified by email.</p>
        </div>;
      case "LOCK_VAULT":
        return <div>
          <p>Are you sure you want to lock this vault? Keyholders will no longer be able to access the documents in this Vault once it is locked.</p>
        </div>;
      case "CANCEL_SUBSCRIPTION":
        return <div>
          <p>Are you sure you want to cancel your subscription? Your vaults will be automatically archived after 60 days if no new subscription is started.</p>
          <p className="mt-3"><a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>Visit our FAQ</a> for more details.</p>
        </div>;
    }
  };

  return (
    <Dialog open={props.openConfirmationModal} onClose={closeModal} fullWidth={true} maxWidth={"md"} className={"confirmation-modal"}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          { getIcon() }
          <p className="text-lg sm:text-2xl font-bold">{getTitle()}</p>
        </div>
        <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer hidden sm:block" onClick={closeModal}/>
      </div>
      <Divider/>
      <div className="my-5 text-sm sm:text-base">
        {getText()}
      </div>
      <Divider/>
      <div className="flex justify-end mt-3">
        <div className="mr-3">
          <Button
            variant="outlined"
            color=""
            onClick={() => props.closeConfirmationModal()}>Cancel</Button>
        </div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {props.confirmationModalOnConfirm(); closeModal();}}>Continue</Button>
        </div>
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    openConfirmationModal: state.utils.openConfirmationModal,
    confirmationModalType: state.utils.confirmationModalType,
    confirmationModalOnConfirm: state.utils.confirmationModalOnConfirm
  };
};


export default compose(
  connect(mapStateToProps, { closeConfirmationModal })
)(ConfirmationModal);